import { all } from 'redux-saga/effects'

import settingSaga from './settingSaga'
import commonLogSaga from './commonLogSaga'
import userSaga from './userSaga'
import notificationSaga from './notificationSaga'

import chiNhanhSaga from './chiNhanhSaga'
import menuSaga from './menuSaga'
import duAnSaga from './duAnSaga'
import roleGroupSaga from './roleGroupSaga'
import heThongSaga from './heThongSaga'
import subAdminSaga from './subAdminSaga'







export default function* rootSaga() {
  yield all([
    settingSaga(),
    commonLogSaga(),
    userSaga(),
    notificationSaga(),
    chiNhanhSaga(),
    menuSaga(),
    duAnSaga(),
    roleGroupSaga(),
    heThongSaga(),
    subAdminSaga(),


  ])
}
